import {
	theme,
	styledSystem as ss,
} from ".";

export type IHeadingProps = ss.ICommonProps & ss.IFontSizeProps & ss.ITypographyProps & {
	n?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const Heading = ss.styled.h1.attrs<IHeadingProps, IHeadingProps>((props) => {
	return {
		fontSize: props.fontSize || `f${props.n || 1}`,
		fontFamily: props.fontFamily || (((props.n || 1) <= 2) ? "display" : undefined),
		as: `h${props.n || 1}`,
	};
})`
	${ss.COMMON}
	${ss.FONTSIZE}
	${ss.TYPOGRAPHY}
`;
Heading.defaultProps = {
	theme,
	n: 1,
	fontWeight: "bold",
	lineHeight: "condensed",
	mt: 0,
	mb: 0,
};

export const H1 = Heading;
export const H2 = ss.styled(Heading)``; H2.defaultProps = { n: 2 };
export const H3 = ss.styled(Heading)``; H3.defaultProps = { n: 3 };
export const H4 = ss.styled(Heading)``; H4.defaultProps = { n: 4 };
export const H5 = ss.styled(Heading)``; H5.defaultProps = { n: 5 };
export const H6 = ss.styled(Heading)``; H6.defaultProps = { n: 6 };
